import type { CdaAutosignService } from '../../application/cdaAutosignService/CdaAutosignService';

export class NoOpCdaAutosignService implements CdaAutosignService {
  warnModalText = undefined;

  signCda = () => {};
}
